<kendo-grid-filter-wrapper-cell #filterWrapper
		[column]="column"
		[filter]="filter"
		[operators]="operators"
		[defaultOperator]="operator"
		[showOperators]="showOperators">
	<input class="k-textbox" [ngModel]="currentFilter?.value" (ngModelChange)="onInputFilterChange($event)">
</kendo-grid-filter-wrapper-cell>



